const cards = [
  {
    id: 1,
    tag: '黑料爆料',
    title: '顶流男星深夜密会被拍，神秘女子身份曝光引发全网热议',
    excerpt: '据知情人士透露，该男星与神秘女子在私人会所密会长达四小时，期间多次亲密互动。网友扒出女子疑似某知名网红，双方工作室暂未回应。吃瓜爆料网将持续跟进事件进展。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20night%20scene%20of%20celebrity%20entering%20luxury%20venue%2C%20warm%20street%20lighting%2C%20mysterious%20atmosphere%2C%20entertainment%20news%20visual%20with%20vibrant%20orange%20and%20coral%20tones%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20high%20contrast%20night%20scene%20on%20clean%20dark%20background&width=800&height=500&seq=card-01-entertainment&orientation=landscape',
    time: '2小时前',
    hot: '98.7万',
  },
  {
    id: 2,
    tag: '反差视频',
    title: '清纯女星私下竟如此开放？私密派对视频流出引争议',
    excerpt: '一段疑似某当红女星的私人派对视频在社交平台疯传，视频中该女星与平时清纯形象大相径庭。粉丝纷纷表示不敢相信，也有网友质疑视频真实性。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20contrast%20between%20elegant%20celebrity%20red%20carpet%20appearance%20and%20hidden%20party%20lifestyle%2C%20split%20visual%20concept%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20news%20photography%2C%20bold%20editorial%20style%2C%20high%20drama%20composition&width=800&height=500&seq=card-02-contrast&orientation=landscape',
    time: '4小时前',
    hot: '86.3万',
  },
  {
    id: 3,
    tag: '塌房现场',
    title: '又一位国民老公塌房！婚内出轨实锤曝光，品牌紧急解约',
    excerpt: '某以好男人形象示人的男星被爆婚内出轨多名女性，女方放出多段聊天记录和亲密合照。目前已有三家品牌宣布终止合作，该男星商业价值面临崩塌。',
    image: 'https://readdy.ai/api/search-image?query=Broken%20luxury%20brand%20billboard%20of%20male%20celebrity%20being%20removed%2C%20dramatic%20urban%20night%20scene%2C%20warm%20orange%20and%20coral%20tones%2C%20editorial%20news%20photography%2C%20sense%20of%20fall%20and%20scandal%2C%20high%20contrast%20composition&width=800&height=500&seq=card-03-collapse&orientation=landscape',
    time: '6小时前',
    hot: '152.1万',
  },
  {
    id: 4,
    tag: '黑料爆料',
    title: '知名导演潜规则女演员录音流出，圈内人纷纷站队表态',
    excerpt: '一段长达15分钟的录音在网络流传，内容涉及某大牌导演以角色为条件要求女演员配合。多位圈内人士在社交平台隐晦表态，事件持续发酵中。',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20silhouette%20on%20dark%20movie%20set%20with%20dramatic%20spotlight%2C%20mysterious%20and%20tense%20atmosphere%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20industry%20scandal%20visual%2C%20editorial%20photography%20style&width=800&height=500&seq=card-04-director&orientation=landscape',
    time: '8小时前',
    hot: '121.5万',
  },
  {
    id: 5,
    tag: '反差视频',
    title: '某综艺咖素颜照流出，网友惊呼：这真的是同一个人？',
    excerpt: '一位以精致妆容著称的综艺明星被拍到素颜出行，与节目中的形象差距巨大。网友评论两极分化，有人表示理解，也有人直呼上当。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20before%20and%20after%20makeup%20comparison%20visual%20of%20celebrity%2C%20split%20screen%20concept%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20news%20photography%2C%20bold%20editorial%20style%2C%20high%20impact%20visual%20contrast&width=800&height=500&seq=card-05-makeup&orientation=landscape',
    time: '10小时前',
    hot: '67.2万',
  },
  {
    id: 6,
    tag: '塌房现场',
    title: '某偶像团体成员涉毒被警方带走，粉丝后援会宣布解散',
    excerpt: '消息人士确认某知名偶像团体成员因涉毒被警方依法传唤，该团体原定下月的演唱会已宣布取消。粉丝后援会发布解散声明，应援物资全部退回。',
    image: 'https://readdy.ai/api/search-image?query=Empty%20concert%20stage%20with%20cancelled%20notice%2C%20dark%20and%20dramatic%20atmosphere%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20scandal%20visual%2C%20editorial%20photography%20style%2C%20somber%20mood%20composition&width=800&height=500&seq=card-06-idol&orientation=landscape',
    time: '12小时前',
    hot: '203.8万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热门爆料</h2>
          <p className="text-sm text-foreground-500">一手吃瓜资讯，实时追踪娱乐圈最新动态</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article key={card.id} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all cursor-pointer">
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base leading-snug mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3 mb-3">
                  {card.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-fire-line"></i>
                    {card.hot}热度
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}